






































































































import {Component, Prop, Vue} from "vue-property-decorator";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";
import ProbabilisticChart from "@/modules/lcca/views/components/ProbablisticChart.vue";
import PxTextArea from "@/views/components/input/formFields/PxTextArea.vue";
import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox.vue";
import QuickHelp from "@/views/components/input/QuickHelp.vue";
import {UnitSystem} from "@/interfaces/units";
import {lccaStore} from "@/store/store";
import {IPerRoadScenarioImperial} from "@/modules/perRoad/interfaces/perRoad";
import PrVehicleDistributionPlot from "@/modules/perRoad/views/components/traffic/PrVehicleDistributionPlot.vue";
import {
  IPrMonteCarloDrawImperial,
  IWesleaConfigBatch,
  IWesleaResultBatch
} from "@/modules/perRoad/interfaces/monteCarlo";
import CriticalLocationDepthInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationDepthInspector.vue";
import CriticalLocationLayoutInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationLayoutInspector.vue";
import {getPeakHorizontalStrain} from "@/modules/perRoad/lib/calculations/horizontalStrainDistribution";

@Component({
  components: {
    CriticalLocationLayoutInspector,
    CriticalLocationDepthInspector,
    PrVehicleDistributionPlot,
    QuickHelp,
    PxTextEntryBox,
    PxTextArea,
    ProbabilisticChart,
    PxDropdown,
    PxNumberInput,
  },
})
export default class WesleaConfigInspector extends Vue {
  @Prop() scenario!: IPerRoadScenarioImperial;

  @Prop() monteCarloDraws!: IPrMonteCarloDrawImperial[];

  @Prop() wesleaConfigs!: IWesleaConfigBatch;

  @Prop() wesleaResults!: IWesleaResultBatch;

  getPeakHorizontalStrain = getPeakHorizontalStrain;

  currentPage = 1;

  plotKey = 0;

  get items() {
    // return Object.values(this.wesleaConfigs)
    return this.monteCarloDraws;
  }

  get fields() {
    return [
      {
        key: "ID",
        label: "Configuration"
      },
      // {key: 'config', sortable: true},
      // {key: 'complete', sortable: true},
      "layers",
      {key: "horizontalStrain", sortable: true},
      "showDetails"
    ];
  }

  get drawIds() {
    return this.monteCarloDraws.map(d => d.id);
  }

  updatePlotKey() {
    this.plotKey += 1;
  }

  sync() {
    this.updatePlotKey();
    this.$emit("sync");
  }

  unitSystemIsImperial() {
    return lccaStore.displayUnits === UnitSystem.Imperial;
  }

}
